import { Trans } from "@lingui/react/macro"
import React, { useRef } from "react"

import UniversalLink from "../../../../design-system/universal-link"
import CatalogDropdown from "../catalog-dropdown"
import DropdownContainer from "../dropdown-container"
import NavDropdown from "../nav-dropdown"
import * as navLinkStyle from "../nav-link/index.module.scss"
import ProductDropdown from "../product-dropdown"
import ResourcesDropdown from "../resources-dropdown"
import UseCasesDropdown from "../use-cases-dropdown"
import * as styles from "./index.module.scss"

enum DROPDOWN_INDEX {
  NEUTRAL_COLLAPSE = -1,
  USE_CASES_DROPDOWN,
  PRODUCT_DROPDOWN,
  RESOURCES_DROPDOWN,
  CATALOG_DROPDOWN,
}

const NavMenuPrimary = () => {
  const dropdownRef = useRef(null)
  const closeMenu = (): void => {
    const activeEl = document.activeElement
    if (activeEl instanceof HTMLElement) {
      activeEl.blur()
    }
  }

  return (
    <div className={styles.navMenuPrimary} ref={dropdownRef}>
      <NavDropdown label={<Trans>Solutions</Trans>} data-testid="solutions">
        <DropdownContainer index={DROPDOWN_INDEX.USE_CASES_DROPDOWN}>
          <UseCasesDropdown />
        </DropdownContainer>
      </NavDropdown>
      <NavDropdown label={<Trans>Product</Trans>} data-testid="product">
        <DropdownContainer index={DROPDOWN_INDEX.PRODUCT_DROPDOWN}>
          <ProductDropdown />
        </DropdownContainer>
      </NavDropdown>
      <NavDropdown label={<Trans>Resources</Trans>} data-testid="resources">
        <DropdownContainer index={DROPDOWN_INDEX.RESOURCES_DROPDOWN}>
          <ResourcesDropdown />
        </DropdownContainer>
      </NavDropdown>
      <NavDropdown label={<Trans>Catalog</Trans>} data-testid="catalog">
        <DropdownContainer index={DROPDOWN_INDEX.CATALOG_DROPDOWN}>
          <CatalogDropdown />
        </DropdownContainer>
      </NavDropdown>
      <UniversalLink
        to="/pricing/"
        className={`${styles.navLink} ${navLinkStyle.navLink}`}
        onMouseUp={closeMenu}
      >
        <div>
          <Trans>Pricing</Trans>
        </div>
      </UniversalLink>
    </div>
  )
}

export default NavMenuPrimary
